import {defineNuxtPlugin, useAsyncData, useHead, useHostSettings, useScripts} from '#imports';

export default defineNuxtPlugin({
    name: 'tracking-host-scripts',
    dependsOn: ['tracking-datalayer'],
    async setup() {
        // Key already populated by tracking-host-settings — resolve from cache.
        const {data: hostSettings, error: hostSettingsError} = await useAsyncData('host-settings', useHostSettings);
        if (hostSettingsError.value || !hostSettings.value?.googleTagManagerId) {
            return;
        }

        const {loadScripts} = useScripts(hostSettings.value);
        const scripts = await loadScripts();
        if (scripts.length === 0) {
            return;
        }

        useHead({script: scripts});
    },
});
